import { onMounted, onUnmounted, watch, type Ref } from 'vue'

interface MultiStepFormNavigationOptions<T> {
  getPreviousStep?: (currentStep: T) => T
}

export const useMultiStepFormNavigation = <T extends number | string | boolean>(
  currentStep: Ref<T>,
  initialStep: T,
  isFormOpen: Ref<boolean> | (() => boolean),
  options?: MultiStepFormNavigationOptions<T>
) => {
  const getIsFormOpen = () => {
    return typeof isFormOpen === 'function' ? isFormOpen() : isFormOpen.value
  }

  const handlePopState = () => {
    if (!getIsFormOpen()) return

    if (currentStep.value !== initialStep) {
      if (options?.getPreviousStep) {
        currentStep.value = options.getPreviousStep(currentStep.value)
      } else {
        currentStep.value = initialStep
      }
    }
  }

  watch(currentStep, (newValue) => {
    if (!getIsFormOpen()) return

    if (newValue !== initialStep) {
      history.pushState(null, '', window.location.href)
    }
  })

  onMounted(() => {
    window.addEventListener('popstate', handlePopState)
  })

  onUnmounted(() => {
    window.removeEventListener('popstate', handlePopState)
  })

  return {
    handlePopState
  }
}
